import React from 'react';

export function BetaBadge({ className = '' }) {
  return (
    <span
      className={`inline-block text-[10px] tracking-[0.14em] uppercase font-semibold text-[#B8860B] border border-[#D4A017]/40 px-2 py-0.5 ${className}`}
    >
      Coming soon
    </span>
  );
}

export function ComingSoonBanner({ children, dark = false }) {
  const wrap = dark
    ? 'border-[#D4A017]/35 bg-[#D4A017]/10 text-white/85'
    : 'border-[#D4A017]/35 bg-[#D4A017]/8 text-[#3F3C38]';
  return (
    <div className={`mb-4 px-4 py-3 border text-sm ${wrap}`}>
      <span className="font-semibold tracking-widest uppercase text-[10px] text-[#D4A017] mr-2">
        Coming soon
      </span>
      {children ||
        'This tool is visible in beta. It is not part of the public launch product yet.'}
    </div>
  );
}

export function PurchaseDisabledButton({ label = 'Purchase' }) {
  return (
    <button
      type="button"
      disabled
      className="w-full bg-gray-200 text-gray-500 py-3 rounded-xl font-semibold cursor-not-allowed text-sm"
    >
      {label} — coming soon
    </button>
  );
}
